import { Checkout } from "@yuno/types";
import { useMemo, useState } from "react";

const queryAttr = "data-rbd-drag-handle-draggable-id";

type PlaceholderProps = {
  clientX?: number;
  clientY?: number;
  clientHeight?: number;
  clientWidth?: number;
};

export const useDraggable = ({ data, onEnd }) => {
  const [placeholderProps, setPlaceholderProps] = useState<PlaceholderProps>(
    {}
  );

  const reorder = (list, startIndex, endIndex): Checkout.PaymentMethods[] => {
    const result: Checkout.PaymentMethods[] = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    return [...result];
  };

  const draggableContainerStyles = useMemo(
    () => ({
      left: placeholderProps.clientX,
      height: placeholderProps.clientHeight,
      top: placeholderProps.clientY,
    }),
    [placeholderProps]
  );

  const onDragUpdate = (update) => {
    if (!update.destination) {
      return;
    }

    const draggableId = update.draggableId;
    const destinationIndex = update.destination.index;

    const domQuery = `[${queryAttr}='${draggableId}']`;
    const draggedDOM = document.querySelector(domQuery);

    if (!draggedDOM) {
      return;
    }

    const { clientHeight, clientWidth } = draggedDOM as Element;

    const clientY =
      // @ts-ignore
      parseFloat(window.getComputedStyle(draggedDOM.parentNode).paddingTop) +
      // @ts-ignore
      [...draggedDOM.parentNode.children]
        .slice(0, destinationIndex)
        .reduce((total, curr) => {
          const style = curr.currentStyle || window.getComputedStyle(curr);
          const marginBottom = parseFloat(style.marginBottom);
          return total + curr.clientHeight + marginBottom;
        }, 0);

    setPlaceholderProps({
      clientHeight,
      clientWidth,
      clientY,
      clientX: parseFloat(
        // @ts-ignore
        window.getComputedStyle(draggedDOM.parentNode).paddingLeft
      ),
    });
  };

  const onDragEnd = (result) => {
    if (!result.destination) {
      return;
    }

    const reordered = reorder(
      data,
      result.source.index,
      result.destination.index
    ).map((el, index) => ({
      ...el,
      order_to_show: index,
    }));

    setPlaceholderProps({});
    onEnd(reordered)
  };

  return {
    reorder,
    draggableContainerStyles,
    placeholderProps,
    setPlaceholderProps,
    onDragUpdate,
    onDragEnd,
  };
};
